import avatarModule from '../avatarModule';

function avatarTabContent(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarTabContent
  };
}

avatarModule.directive('avatarTabContent', avatarTabContent);

export default avatarTabContent;
